export enum TPrintErrorCodes {
  T_PRINTER_STATUS_ERROR = 'T_PRINTER_STATUS_ERROR',
  T_PRINT_ERROR = 'T_PRINT_ERROR',
}
